import { render, staticRenderFns } from "./CircularGauge.vue?vue&type=template&id=38ea678b&"
import script from "./CircularGauge.vue?vue&type=script&lang=js&"
export * from "./CircularGauge.vue?vue&type=script&lang=js&"
import style0 from "./CircularGauge.vue?vue&type=style&index=0&id=38ea678b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports